import { useSelector } from "react-redux";

import { RootState } from "../store/store";

// Hook: determines if user can see the new Maguire UI or read new data
export function useIsMaguireEnabled(): boolean {
  const isMaguireTransitionState = useSelector((state: RootState) => state.appConfigs.isMaguireTransitionState);
  const isNewSystemFlow = useSelector((state: RootState) => state.appConfigs.isNewSystemFlow);
  return isNewSystemFlow || isMaguireTransitionState;
}

// Hook: determines if user can write / send data to Maguire system
export function useIsNewSystemFlow(): boolean {
  return useSelector((state: RootState) => state.appConfigs.isNewSystemFlow);
}

// Hook: determines if user can write / send data to Maguire system DebtCategoryId
export function useMaguireTransitionDay2(): boolean {
  const isMaguireTransitionDay2 = useSelector((state: RootState) => state.appConfigs.isMaguireTransitionDay2);
  const isMaguireTransitionState = useSelector((state: RootState) => state.appConfigs.isMaguireTransitionState);

  return isMaguireTransitionState && isMaguireTransitionDay2;
}

export function useMaguireWeeklyBillingCycleCutOffId(): number {
  const weeklyBillingCycleCutOffId = useSelector((state: RootState) => state.appConfigs.weeklyBillingCycleCutOffId);
  return weeklyBillingCycleCutOffId;
}
